/**
 * Drag and Drop Type Definitions for Edit Terminal Photo Layout
 * 
 * These types define the structure of drag items and drop results
 * used in the three-panel layout drag-and-drop system.
 */

/**
 * Type identifier for draggable photos
 * Used by react-dnd to match drag sources with drop targets
 */
export const DRAG_TYPES = {
  PHOTO: 'PHOTO',
} as const;

/**
 * Data structure for a photo being dragged from the gallery
 */
export interface DraggedPhoto {
  /** Unique identifier of the photo being dragged */
  photoId: string;
  /** Sequence number of the photo in the order */
  sequence: number;
}

/**
 * Result returned when a photo is dropped into a slot
 */
export interface PhotoDropResult {
  /** Index of the slot where the photo was dropped */
  slotIndex: number;
  /** Whether the drop was successful */
  success: boolean;
}

/**
 * Props collected by useDrag hook for drag source components
 */
export interface DragCollectedProps {
  /** Whether this item is currently being dragged */
  isDragging: boolean;
  /** Whether the drag operation can start */
  canDrag: boolean;
}

/**
 * Props collected by useDrop hook for drop target components
 */
export interface DropCollectedProps {
  /** Whether a dragged item is currently over this drop target */
  isOver: boolean;
  /** Whether this drop target can accept the current dragged item */
  canDrop: boolean;
}
